export enum HistoryMutationTypes {
  SET_PORTFOLIO_HISTORY = 'SET_PORTFOLIO_HISTORY',
  SET_HISTORY_LIST = 'SET_HISTORY_LIST',
}
